import React, { Fragment, useEffect, useState } from 'react';
import { connect } from "react-redux";
import Pagination from '../Pagination/Pagination';
import { ACTIVE_PARAMETERS, PARAMETER_UNIT_IDS, VENTI_PAGE_TEMPLATE, VENTILATOR_ADDITIONAL_FEATURES } from '../../common/ENUMS/PARAMETER_ENUM';
import { USER_VIEW } from "../../common/constant/common-constants";

import offlineIcon from "../../common/icons/svg/ventilator-offline.svg"
import standbyIcon from "../../common/icons/svg/no-ventilation.svg"
import { alarmBackground } from '../../common/utils/CommonUtils';
import VentilatorSetParams from '../VentilatorSetParams/VentilatorSetParams';
import VentilatorChart from '../VentilatorChart/VentilatorChart.jsx';
import DevicesTab from "../../container/PatientRightPanel/MachineTabs/DevicesTab.jsx";
import VentilatorVitalDataDesktopView from "./VentilatorVitalDataDesktopView";
import VentilatorVitalDataMobileView from "./VentilatorVitalDataMobileView";

function VentilatorVitalData(props) {
    const [visibleParameters, setvisibleParameters] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    // const dummyData = {
    //     "basic_params": {
    //         "fio2": { "id": 104001, "key": "fio2", "unit": 103502, "value": 21.5, "alarm_limit": [18, 25], "alarms": [[101, "low"], [102, "high"]] },
    //         "pip": { "id": 104002, "key": "pip", "unit": 103503, "value": 28, "alarm_limit": [15, 35], "alarms": [] },
    //         "peep": { "id": 104003, "key": "peep", "unit": 103503, "value": 8.12, "alarm_limit": [5, 12], "alarms": [[101, "low"], [102, "medium"]] },
    //         "rr": { "id": 104004, "key": "rr", "unit": 103506, "value": 18, "alarm_limit": [12, 25], "alarms": [] },
    //         "i_e": { "id": 104005, "key": "i_e", "unit": 103501, "value": 1.2, "alarm_limit": [0.8, 2.0], "alarms": [[101, "low"], [102, "high"]] },
    //         "leakage_vt": { "id": 104006, "key": "leakage_vt", "unit": 103502, "value": 5, "alarm_limit": [0, 10], "alarms": [[101, "low"], [102, "high"]] },
    //         "vti": { "id": 104007, "key": "vti", "unit": 103508, "value": 450, "alarm_limit": [300, 600], "alarms": [] },
    //         "vte": { "id": 104008, "key": "vte", "unit": 103508, "value": 440, "alarm_limit": [300, 600], "alarms": [[101, "low"], [102, "high"]] },
    //         "mve": { "id": 104009, "key": "mve", "unit": 103512, "value": 6.1, "alarm_limit": [4, 10], "alarms": [[101, "low"], [102, "high"]] },
    //         "mvi": { "id": 104010, "key": "mvi", "unit": 103512, "value": 8, "alarm_limit": [4, 10], "alarms": [[101, "low"], [102, "high"]] },
    //         "mve_spont": { "id": 104011, "key": "mve_spont", "unit": 103512, "value": 5.5, "alarm_limit": [3, 8], "alarms": [[101, "low"], [102, "high"]] },
    //         "vte_spont": { "id": 104012, "key": "vte_spont", "unit": 103508, "value": 400, "alarm_limit": [250, 500], "alarms": [[101, "low"], [102, "high"]] },
    //         "flow_rate": { "id": 104013, "key": "flow_rate", "unit": 103512, "value": 35, "alarm_limit": [20, 60], "alarms": [[101, "low"], [102, "high"]] },
    //         "c_static": { "id": 104014, "key": "c_static", "unit": 103509, "value": 50, "alarm_limit": [30, 70], "alarms": [[101, "low"], [102, "high"]] },
    //         "c_dynamic": { "id": 104015, "key": "c_dynamic", "unit": 103509, "value": 45, "alarm_limit": [25, 65], "alarms": [[101, "low"], [102, "high"]] },
    //         "p_drive": { "id": 104016, "key": "p_drive", "unit": 103503, "value": 15, "alarm_limit": [10, 25], "alarms": [[101, "low"], [102, "high"]] },
    //         "rr_spont": { "id": 104017, "key": "rr_spont", "unit": 103506, "value": 16, "alarm_limit": [10, 24], "alarms": [[101, "low"], [102, "high"]] },
    //         "pwob": { "id": 104018, "key": "pwob", "unit": 103514, "value": 0.8, "alarm_limit": [0, 2], "alarms": [[101, "low"], [102, "high"]] },
    //         "p01": { "id": 104019, "key": "p01", "unit": 103501, "value": 2, "alarm_limit": [1, 4], "alarms": [[101, "low"], [102, "high"]] },
    //         "pmean": { "id": 104020, "key": "pmean", "unit": 103503, "value": 12, "alarm_limit": [8, 18], "alarms": [[101, "low"], [102, "medium"]] },
    //         "ti": { "id": 104021, "key": "ti", "unit": 103513, "value": 1.0, "alarm_limit": [0.5, 1.5], "alarms": [[101, "low"], [102, "high"]] },
    //         "te": { "id": 104022, "key": "te", "unit": 103513, "value": 2.0, "alarm_limit": [1.0, 3.0], "alarms": [[101, "low"], [102, "high"]] },
    //         "ri": { "id": 104023, "key": "ri", "unit": 103505, "value": 5, "alarm_limit": [3, 8], "alarms": [[101, "low"], [102, "high"]] },
    //         "re": { "id": 104024, "key": "re", "unit": 103505, "value": 4.8, "alarm_limit": [3, 8], "alarms": [[101, "low"], [102, "high"]] },
    //         "flow_ee": { "id": 104025, "key": "flow_ee", "unit": 103512, "value": 30, "alarm_limit": [15, 50], "alarms": [[101, "low"], [102, "high"]] },
    //         "rsbi": { "id": 104026, "key": "rsbi", "unit": 103507, "value": 45, "alarm_limit": [20, 60], "alarms": [[101, "low"], [102, "high"]] },
    //         "elastance": { "id": 104027, "key": "elastance", "unit": 103504, "value": 0.02, "alarm_limit": [0.01, 0.05], "alarms": [[101, "low"], [102, "high"]] },
    //         "tv_pbw": { "id": 104028, "key": "tv_pbw", "unit": 103510, "value": 7, "alarm_limit": [6, 8], "alarms": [[101, "low"], [102, "high"]] },
    //         "tv_bw": { "id": 104029, "key": "tv_bw", "unit": 103510, "value": 6.5, "alarm_limit": [5, 8], "alarms": [[101, "low"], [102, "high"]] },
    //         "tc_insp": { "id": 104030, "key": "tc_insp", "unit": 103513, "value": 0.8, "alarm_limit": [0.5, 1.5], "alarms": [[101, "low"], [102, "high"]] },
    //         "tc_exp": { "id": 104031, "key": "tc_exp", "unit": 103513, "value": 1.2, "alarm_limit": [0.8, 2.0], "alarms": [[101, "low"], [102, "high"]] },
    //         "wob_vent": { "id": 104032, "key": "wob_vent", "unit": 103514, "value": 0.9, "alarm_limit": [0, 2], "alarms": [[101, "low"], [102, "high"]] },
    //         "wob_i": { "id": 104033, "key": "wob_i", "unit": 103514, "value": 0.8, "alarm_limit": [0, 2], "alarms": [[101, "low"], [102, "high"]] },
    //         "stress_index": { "id": 104034, "key": "stress_index", "unit": 103501, "value": 100.0, "alarm_limit": [0.8, 1.2], "alarms": [[101, "low"], [102, "high"]] },
    //         "ti_spont_ttotal": { "id": 104035, "key": "ti_spont_ttotal", "unit": 103502, "value": 30, "alarm_limit": [20, 40], "alarms": [[101, "low"], [102, "high"]] },
    //         "p_plateau": { "id": 104036, "key": "p_plateau", "unit": 103503, "value": 20, "alarm_limit": [15, 30], "alarms": [[101, "low"], [102, "high"]] },
    //         "auto_peep": { "id": 104037, "key": "auto_peep", "unit": 103503, "value": 5, "alarm_limit": [0, 10], "alarms": [[101, "low"], [102, "high"]] },
    //         "trapped_volume": { "id": 104038, "key": "trapped_volume", "unit": 103508, "value": 150, "alarm_limit": [100, 300], "alarms": [[101, "low"], [102, "high"]] },
    //     },
    //     "spo2_params": {
    //         "spo2": { "id": 104301, "key": "spo2", "unit": 103502, "value": 97, "alarm_limit": [90, 100], "alarms": [[101, "low"], [102, "high"]] },
    //         "pulse_rate": { "id": 104302, "key": "pulse_rate", "unit": 103506, "value": 78, "alarm_limit": [50, 120], "alarms": [[101, "low"], [102, "high"]] },
    //         "perfusion_index": { "id": 104303, "key": "perfusion_index", "unit": 103502, "value": 2.5, "alarm_limit": [0, 6], "alarms": [[101, "low"], [102, "high"]] },
    //     },
    //     "capnography_params": {
    //         "fetco2": { "id": 104401, "key": "fetco2", "unit": 103502, "value": 5.2, "alarm_limit": [4, 6], "alarms": [[101, "low"], [102, "high"]] },
    //         "petco2": { "id": 104402, "key": "petco2", "unit": 103515, "value": 38, "alarm_limit": [30, 45], "alarms": [[101, "low"], [102, "high"]] },
    //         "vtco2": { "id": 104403, "key": "vtco2", "unit": 103508, "value": 350, "alarm_limit": [200, 500], "alarms": [[101, "low"], [102, "high"]] },
    //         "mvco2": { "id": 104404, "key": "mvco2", "unit": 103511, "value": 6.0, "alarm_limit": [4, 10], "alarms": [[101, "low"], [102, "high"]] },
    //         "vdphys": { "id": 104405, "key": "vdphys", "unit": 103508, "value": 150, "alarm_limit": [100, 300], "alarms": [[101, "low"], [102, "high"]] },
    //         "vdanat": { "id": 104406, "key": "vdanat", "unit": 103508, "value": 120, "alarm_limit": [80, 200], "alarms": [[101, "low"], [102, "high"]] },
    //         "vdanat__vte": { "id": 104407, "key": "vdanat__vte", "unit": 103502, "value": 35, "alarm_limit": [20, 50], "alarms": [[101, "low"], [102, "high"]] },
    //         "vdalv": { "id": 104408, "key": "vdalv", "unit": 103508, "value": 200, "alarm_limit": [100, 300], "alarms": [[101, "low"], [102, "high"]] },
    //         "vdalv__vte": { "id": 104409, "key": "vdalv__vte", "unit": 103502, "value": 50, "alarm_limit": [30, 60], "alarms": [[101, "low"], [102, "high"]] },
    //         "slopeco2": { "id": 104410, "key": "slopeco2", "unit": 103516, "value": 3.5, "alarm_limit": [2, 5], "alarms": [[101, "low"], [102, "high"]] },
    //         "vtalv": { "id": 104411, "key": "vtalv", "unit": 103508, "value": 300, "alarm_limit": [200, 500], "alarms": [[101, "low"], [102, "high"]] },
    //         "mvalv": { "id": 104412, "key": "mvalv", "unit": 103512, "value": 5.5, "alarm_limit": [4, 10], "alarms": [[101, "low"], [102, "high"]] },
    //         "vto2": { "id": 104413, "key": "vto2", "unit": 103508, "value": 400, "alarm_limit": [300, 600], "alarms": [[101, "low"], [102, "high"]] },
    //         "ee": { "id": 104414, "key": "ee", "unit": 103517, "value": 1500, "alarm_limit": [1000, 2000], "alarms": [[101, "low"], [102, "high"]] },
    //         "rq": { "id": 104415, "key": "rq", "unit": 103501, "value": 0.85, "alarm_limit": [0.7, 1.0], "alarms": [[101, "low"], [102, "high"]] },
    //         "co2_gradient": { "id": 104416, "key": "co2_gradient", "unit": 103515, "value": 5, "alarm_limit": [2, 8], "alarms": [[101, "low"], [102, "high"]] },
    //         "pao2": { "id": 104417, "key": "pao2", "unit": 103515, "value": 90, "alarm_limit": [80, 100], "alarms": [[101, "low"], [102, "high"]] },
    //         "bgd_pao2__fio2": { "id": 104418, "key": "bgd_pao2__fio2", "unit": 103501, "value": 4.2, "alarm_limit": [3, 5], "alarms": [[101, "low"], [102, "high"]] },
    //         "bgd_pao2__pao2": { "id": 104419, "key": "bgd_pao2__pao2", "unit": 103501, "value": 1.1, "alarm_limit": [0.8, 1.5], "alarms": [[101, "low"], [102, "high"]] },
    //         "oi": { "id": 104420, "key": "oi", "unit": 103501, "value": 7, "alarm_limit": [5, 15], "alarms": [[101, "low"], [102, "high"]] },
    //         "spo2__fio2": { "id": 104421, "key": "spo2__fio2", "unit": 103501, "value": 4.6, "alarm_limit": [3, 6], "alarms": [[101, "low"], [102, "high"]] },
    //     },
    //     "basic_visible_params": [
    //         104001, 104002, 104003, 104004, 104005, 104006, 104007, 104008, 104009, 104010,
    //         104011, 104012, 104013, 104014, 104015, 104016, 104017, 104018, 104019, 104020,
    //         104021, 104022, 104023, 104024, 104025, 104026, 104027, 104028, 104029, 104030,
    //         104031, 104032, 104033, 104034, 104035, 104036, 104037, 104038
    //     ],
    //     "spo2_visible_params": [
    //         104301, 104302, 104303
    //     ],
    //     "capnography_visible_params": [
    //         104401, 104402, 104403, 104404, 104405, 104406, 104407, 104408, 104409,
    //         104410, 104411, 104412, 104413, 104414, 104415, 104416, 104417, 104418, 104419,
    //         104420, 104421
    //     ]
    // }

    useEffect(() => {
        // --- Extract data safely ---

        const basic_params_data = props?.ventilatorVitalData?.basic_params
            ? Object.values(props.ventilatorVitalData.basic_params)
            : [];

        const spo2_params_data = props?.ventilatorVitalData?.spo2_params
            ? Object.values(props.ventilatorVitalData.spo2_params)
            : [];

        const capnography_params_data = props?.ventilatorVitalData?.capnography_params
            ? Object.values(props.ventilatorVitalData.capnography_params)
            : [];

        // --- Visible params safely ---
        const basic_visible_params_ids = Array.isArray(props?.ventilatorVitalData?.basic_visible_params)
            ? props.ventilatorVitalData.basic_visible_params
            : [];

        const spo2_visible_params_ids = Array.isArray(props?.ventilatorVitalData?.spo2_visible_params)
            ? props.ventilatorVitalData.spo2_visible_params
            : [];

        const capnography_visible_params_ids = Array.isArray(props?.ventilatorVitalData?.capnography_visible_params)
            ? props.ventilatorVitalData.capnography_visible_params
            : [];


        // const basic_params_data = dummyData?.basic_params
        //     ? Object.values(dummyData.basic_params)
        //     : [];

        // const spo2_params_data = dummyData?.spo2_params
        //     ? Object.values(dummyData.spo2_params)
        //     : [];

        // const capnography_params_data = dummyData?.capnography_params
        //     ? Object.values(dummyData.capnography_params)
        //     : [];

        // // --- Visible params safely ---
        // const basic_visible_params_ids = Array.isArray(dummyData?.basic_visible_params)
        //     ? dummyData.basic_visible_params
        //     : [];

        // const spo2_visible_params_ids = Array.isArray(dummyData?.spo2_visible_params)
        //     ? dummyData.spo2_visible_params
        //     : [];

        // const capnography_visible_params_ids = Array.isArray(dummyData?.capnography_visible_params)
        //     ? dummyData.capnography_visible_params
        //     : [];

        const visible_parameters_data = [

            ...(basic_params_data || []).filter(param =>
                basic_visible_params_ids.includes(param?.id)
            ),

            ...(spo2_params_data || []).filter(param =>
                spo2_visible_params_ids.includes(param?.id)
            ),

            ...(capnography_params_data || []).filter(param =>
                capnography_visible_params_ids.includes(param?.id)
            )
        ].filter(Boolean);

        // --- Finally set them ---
        setvisibleParameters(visible_parameters_data || []);

    }, [props?.ventilatorVitalData])

    // console.log(props.monitoringVitalsView)

    return (
        <>
            {props.config.userView === USER_VIEW.DESKTOP && (
                <VentilatorVitalDataDesktopView
                    props={props}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    visibleParameters={visibleParameters}
                />
            )}

            {props.config.userView === USER_VIEW.MOBILE && (
                <VentilatorVitalDataMobileView
                    props={props}
                    visibleParameters={visibleParameters}
                />
            )}
        </>

    )

}

const mapStateToProps = (state, ownProps) => {
    let vData = state.deviceVitalDataReducer.ventilatorVitalData
        && state.deviceVitalDataReducer.ventilatorVitalData[ownProps.bedId]
        && state.deviceVitalDataReducer.ventilatorVitalData[ownProps.bedId]['ventilatorVitalData'];
    let ventilatorPatientModeAlarmProfileData = state?.deviceVitalDataReducer?.ventilatorPatientModeAlarmProfileData?.[ownProps.bedId];
    let ventilatorHeartbeat = state.deviceVitalDataReducer?.ventilatorHeartbeat?.[ownProps.bedId];
    let ventilatorStandby = state.deviceVitalDataReducer?.ventilatorStandby?.[ownProps.bedId];
    let alarmData = state?.alarmDataReducer?.alarmData?.[ownProps.bedId];
    let ventilatorAdditionalFeaturesData =
        state.deviceVitalDataReducer?.ventilatorHeartbeat?.[ownProps.bedId] ?
            state?.deviceVitalDataReducer?.ventilatorAdditionalFeaturesData?.[ownProps.bedId]?.ventilatorAdditionalFeaturesData
            : [];
    let ventilatorModuleConnectionStatus =
        state.deviceVitalDataReducer?.ventilatorHeartbeat?.[ownProps.bedId] ?
            state?.deviceVitalDataReducer?.ventilatorModuleConnectionStatus?.[ownProps.bedId]?.ventilatorModuleConnectionStatus
            : [];


    return {
        ventilatorVitalData: vData,
        ventilatorPatientModeAlarmProfileData: ventilatorPatientModeAlarmProfileData,
        ventilatorHeartbeat: ventilatorHeartbeat,
        ventilatorStandby: ventilatorStandby,
        config: state.configReducer.config,
        alarmData: alarmData,
        ventilatorAdditionalFeaturesData: ventilatorAdditionalFeaturesData,
        ventilatorModuleConnectionStatus: ventilatorModuleConnectionStatus

    }
}

export default connect(mapStateToProps, null)(VentilatorVitalData);